import * as React from "react";
const SvgFiRrCactus = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-cactus_svg__a)">
      <path d="M22.981 10.733a3 3 0 0 0-2.439-.674c-1.427.232-2.503 1.551-2.503 3.067v.893h-1V5.191c0-2.646-1.982-4.907-4.513-5.149a5.04 5.04 0 0 0-3.85 1.277 5 5 0 0 0-1.639 3.7v4h-1v-.893c0-1.516-1.076-2.834-2.504-3.067a3.003 3.003 0 0 0-3.495 2.96v2c0 2.757 2.243 5 5 5h2v5c0 2.206 1.794 4 4 4h2c2.206 0 4-1.794 4-4h2c2.757 0 5-2.243 5-5v-2a3 3 0 0 0-1.057-2.286m-.943 4.286c0 1.654-1.346 3-3 3h-3a1 1 0 0 0-1 1v1c0 1.103-.897 2-2 2h-2c-1.103 0-2-.897-2-2v-6a1 1 0 0 0-1-1h-3c-1.654 0-3-1.346-3-3v-2a1 1 0 0 1 1.175-.986c.463.076.825.556.825 1.093v.893c0 1.103.897 2 2 2h1c1.103 0 2-.897 2-2v-4c0-.843.358-1.652.982-2.22a2.97 2.97 0 0 1 2.316-.765c1.515.145 2.701 1.531 2.701 3.157v8.828c0 1.103.897 2 2 2h1c1.103 0 2-.897 2-2v-.893c0-.538.362-1.018.824-1.093a1.001 1.001 0 0 1 1.176.986z" />
      <path d="M11.5 20a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M11.5 8a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M12.5 14a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" />
    </g>
    <defs>
      <clipPath id="fi-rr-cactus_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCactus;
